import BottomFloatingModal from "components/common/Modal/BottomFloatingModal";
import useModalClickOutside from "utils/useModalClickOutside";
import { TYPO } from "styles/Typo";
import { Expand, Forward } from "components/common/Icons";
import { TrackedLink } from "lib/analytics/react/link";
import { useTranslation } from "next-i18next";

function TopicSelectModal({
  setModalOpen,
  isModalOpen,
  data,
}: {
  isModalOpen: boolean;
  setModalOpen: any;
  data: any;
}) {
  const modalRef = useModalClickOutside(setModalOpen);
  const { t } = useTranslation("main");

  return (
    <BottomFloatingModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      isIosFixedBottomButtonFlag={false}
    >
      <div className="flex flex-col gap-4 w-full pb-2">
        <div className="px-6 pt-6">
          <span className={`${TYPO.TYPO4_SB} text-gray80`}>
            {t("hotTopics")}
          </span>
        </div>
        <div className="py-2 flex flex-col gap-2">
          {data?.map((item: any, index: number) => {
            return (
              <TrackedLink
                href={`/topic?tpid=${item.id}`}
                asTrace={true}
                itemspec={{
                  kind: "topic",
                  topic_id: item.id,
                  rank: index + 1,
                }}
                fromListId="hottopic_topic_list"
                className="px-6 py-2 flex items-center cursor-pointer justify-between gap-2"
                key={index}
                onClick={() => {
                  setModalOpen(false);
                }}
              >
                <span
                  className={`${TYPO.TYPO5_1_MD} text-gray80 break-all break-words`}
                >
                  {item?.title}
                </span>
                <div className="shrink-0">
                  <Forward fill="gray40" width={16} height={16} />
                </div>
              </TrackedLink>
            );
          })}
        </div>
      </div>
    </BottomFloatingModal>
  );
}

export default TopicSelectModal;
